/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createEnqueueFetchChargePointConsumptionResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeEnqueueFetchChargePointConsumptionCommand, serializeEnqueueFetchChargePointConsumptionResult, type EnqueueFetchChargePointConsumptionCommand, type EnqueueFetchChargePointConsumptionResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /fetch/chargepoint-consumption-enqueue
 */
export interface ChargepointConsumptionEnqueueRequestBuilder extends BaseRequestBuilder<ChargepointConsumptionEnqueueRequestBuilder> {
    /**
     * EnqueueFetchChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<EnqueueFetchChargePointConsumptionResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: EnqueueFetchChargePointConsumptionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<EnqueueFetchChargePointConsumptionResult | undefined>;
    /**
     * EnqueueFetchChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: EnqueueFetchChargePointConsumptionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ChargepointConsumptionEnqueueRequestBuilderUriTemplate = "{+baseurl}/fetch/chargepoint-consumption-enqueue";
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargepointConsumptionEnqueueRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ChargepointConsumptionEnqueueRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createEnqueueFetchChargePointConsumptionResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeEnqueueFetchChargePointConsumptionCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
